











































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Building from '@/data/models/building';
import {nonEmpty, requiredRule} from '@/helpers/rules-validator';

@Component({})
export default class ConfigForm extends Vue {

  @Prop({required: true})
  buildingForm: Building;

  get requiredRules(): any[] {
    return requiredRule(this.$t('rules.required.empty').toString());
  }

  get nonEmptyRule(): any[] {
    return nonEmpty(this.$t('rules.required.empty').toString());
  }
}
